function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityAssetAdded = function SvgActivityAssetAdded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    style: {
      fill: "#fff",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 1.1a10 10 0 1 0 10 10 10.029 10.029 0 0 0-10-10zm0 18.2a8.1 8.1 0 1 1 8.1-8.1 8.066 8.066 0 0 1-8.1 8.1z",
    "data-name": "Path 11830",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(-1.416 -.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 10.1a.945.945 0 0 1 1 1 .945.945 0 0 1-1 1h-3.1v3.1a1 1 0 0 1-2 0v-3.1H8.4a.945.945 0 0 1-1-1 .945.945 0 0 1 1-1h3.1V7a1 1 0 0 1 2 0v3.1z",
    "data-name": "Path 11831",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(-1.416 -.1)"
  }));
};
export default SvgActivityAssetAdded;